import { ReactNode, useState } from "react";
import { AssetType } from "@zapier/canvas-state";
import { AssetDetailsButton } from "../AssetDetailsButton";
import styles from "./AssetPreviewWrapper.module.css";

type Props = {
  id: string;
  assetType: AssetType;
  assetId: string | undefined | null;
  showAssetDetailsButton: boolean;
  projectId: string | undefined;
  children: ReactNode;
};

export function AssetPreviewWrapper({
  id,
  assetType,
  assetId,
  showAssetDetailsButton,
  projectId,
  children,
}: Props) {
  const [hoveringOverAssetDetailsButton, setHoveringOverAssetDetailsButton] =
    useState(false);

  const onMouseOverAssetDetailsButton = (hovering: boolean) => {
    setHoveringOverAssetDetailsButton(hovering);
  };

  return (
    <div
      className={styles.root}
      onFocus={() => onMouseOverAssetDetailsButton(true)}
      onMouseOver={() => onMouseOverAssetDetailsButton(true)}
      onBlur={() => onMouseOverAssetDetailsButton(false)}
      onMouseLeave={() => onMouseOverAssetDetailsButton(false)}
    >
      {children}
      {assetId && showAssetDetailsButton && (
        <AssetDetailsButton
          id={id}
          assetType={assetType}
          assetId={assetId}
          interfaceProjectId={projectId!}
          hoveringOverAssetDetailsButton={hoveringOverAssetDetailsButton}
        />
      )}
    </div>
  );
}
